<script lang="ts">
	import type { SiteConfig } from '$lib/types';

	interface Props {
		site: SiteConfig;
	}

	let { site }: Props = $props();
</script>

<footer class="site-footer">
	<div class="container footer-inner">
		<p>© {new Date().getFullYear()} {site.name}. All rights reserved.</p>
		<ul class="footer-links">
			<li>
				<a href={site.urls.github} rel="noopener noreferrer">GitHub</a>
			</li>
			<li>
				<a href={site.urls.x} rel="noopener noreferrer">X</a>
			</li>
			<li>
				<a href={site.urls.blog}>Blog</a>
			</li>
			<li>
				<a href="/verify">Verify</a>
			</li>
			<li>
				<a href={site.pgp.path} title="OpenPGP public key ({site.pgp.fingerprint})">Public key</a>
			</li>
		</ul>
	</div>
</footer>
